import { Box, Typography } from '@mui/material';
import { analyticsColors } from './analyticsStyles';

interface Props {
  label: string;
  value: string | number;
  highlight?: boolean;
  negative?: boolean;
}

export const SalesMetricCard = ({
  label,
  value,
  highlight,
  negative,
}: Props) => {
  const valueColor = highlight
    ? analyticsColors.growthPositive
    : negative
      ? analyticsColors.growthNegative
      : analyticsColors.metricValue;

  return (
    <Box
      sx={{
        px: 1.5,
        py: 2,
        bgcolor: analyticsColors.cardBg,
        border: `1px solid ${analyticsColors.cardBorder}`,
        borderRadius: '12px',
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          fontSize: '0.6875rem',
          fontWeight: 500,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: analyticsColors.metricLabel,
          mb: 1,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.375rem',
          fontWeight: 700,
          color: valueColor,
          lineHeight: 1.2,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
